<div [formGroup]="formGroup">
  <editor [init]="config" [formControlName]="field.name"></editor>
</div>

<!--div [formGroup]="formGroup">
  <textarea [formControlName]="field.name" [id]="field.name"></textarea>
</div-->
